import React, { useState } from 'react';
import { Headphones } from 'lucide-react';
import { formatTime } from '@/utils/commsFormat';

// "Played 10:43" for 1:1 voice clips, "Played by N" (tap for names) in channels.
export const PlayedMarker = ({ plays, channel }) => {
  const [open, setOpen] = useState(false);
  if (!plays?.length) return null;

  if (channel) {
    return (
      <div className="seen-marker" data-testid="played-marker">
        <button type="button" className="seen-toggle" onClick={() => setOpen((o) => !o)} data-testid="played-by-toggle">
          <Headphones size={12} /> Played by {plays.length}
        </button>
        {open && (
          <div className="seen-list" data-testid="played-by-list">
            {plays.map((p) => <span key={p.user_id}>{p.user_name || 'Unknown'} · {formatTime(p.played_at)}</span>)}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="seen-marker" data-testid="played-marker">
      <Headphones size={12} /> Played {formatTime(plays[0].played_at)}
    </div>
  );
};
